
export type AuthUser = {
    Id: string;
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Email: string;
    PictureLink?: string;
    IsExistingUser: boolean;
    RolesList: string[];
  };

export function newAuthUser():AuthUser{
  return {
      Id: "",
      FirstName: "",
      LastName: "",
      DisplayName: "",
      Email: "",
      PictureLink: "",
      IsExistingUser: false,
      RolesList:[]
  };
};